import React from "react";
import logo from "@/assets/svg/footerlogo.png";
import mail from "@/assets/svg/mail.svg";
import pin from "@/assets/svg/pin.svg";
import "./Footer.css";
const Footer = () => {
  return (
    <div className="reportFooter">
      <img style={{ width: "9rem" }} src={logo} alt="Logo" />
      <div className="Footer_info">
        <div className="Footer_info">
          <img src={mail} alt="mail" />
          <p>info@infinitylearn.com</p>
        </div>
        <div className="Footer_info">
          <img src={pin} alt="loaction" />
          <p>
            Infinity Towers, Plot No 2-91/31, <br />
            Near N Convention, HITEC City, Hyderabad, Telangana 500081.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
